import axios from "axios";
import { API } from "./api";

const DKEY = "afae-device";
export function deviceId() {
  let d = localStorage.getItem(DKEY);
  if (!d) {
    d = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, "");
    localStorage.setItem(DKEY, d);
  }
  return d;
}
const headers = () => ({ "X-Device": deviceId() });

export const hearts = { counts: {}, mine: new Set(), loaded: false };
export async function loadHearts() {
  const { data } = await axios.get(`${API}/hearts`, { headers: headers() });
  hearts.counts = data.counts;
  hearts.mine = new Set(data.mine);
  hearts.loaded = true;
  return hearts;
}
export async function toggleHeart(id) {
  const { data } = await axios.post(`${API}/hearts/${id}`, null, { headers: headers() });
  if (data.hearted) hearts.mine.add(id);
  else hearts.mine.delete(id);
  hearts.counts[id] = data.count;
  window.dispatchEvent(new CustomEvent("afae-hearts"));
  return data.hearted;
}
export const sendLetter = (body) => axios.post(`${API}/letters`, body, { headers: headers() });
export const openLetter = (detail = {}) => window.dispatchEvent(new CustomEvent("afae-letter", { detail }));
